import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(codFiveBono, codValeFiveBono, numFichaVtaVeh, numProfVeh, codEstadoVale, codColaborador,obsBono) {


  const config = {
      params:{

      },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data ={
    codColaborador,
    codValeFiveBono,
    numFichaVtaVeh,
    numProfVeh,
    codEstadoVale,
    obsBono
  }

  return customAxios.put(`${FDV_URL}/ficha-venta/fichas-ventas/${codFiveBono}/actualizar`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/updateEstadoVale.js